import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "@components/layout";
import SEO from "@components/seo";
import Zoom from "react-reveal/Zoom";

import { LazyLoadComponent } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import PostModal from "@components/blogPostModal/modal";

import { StaticImage } from "gatsby-plugin-image";

import HeroSwiper from "@components/swiper/hero-swiper-responsive";
import About from "@components/sections/about-us";
import Products from "@components/sections/products";
import Arbor from "@components/sections/arbor";
import Flow from "@components/sections/flow";
import Foundation from "@components/sections/foundation";
import Shop from "@components/sections/shop";
import Pre from "@components/sections/pre-footer";

// images
import Logo from "@images/fluo-logo-white.svg";
import Post1Background from "@images/open-book-alive.jpg";
import Post2Background from "@images/lux-bands.jpg";
import Post3Background from "@images/fluo-foundation.png";

import Merchandise from "@components/merchandise/merchandise";

const IndexPage = ({ data }) => {
	return (
		<Layout>
			<SEO title="The Art of Living | FLUO" />
			<div className="index">
				<HeroSwiper />
				<About />
				<Products />
				<Arbor />
				<Flow />
				<Foundation />
				<Shop />
				<Pre />
			</div>
		</Layout>
	);
};

export default IndexPage;

export const indexPageQuery = graphql`
	query indexPageQuery {
		site {
			siteMetadata {
				title
				author
				description
			}
		}
		allSanityPost(sort: { order: ASC, fields: publishedAt }, limit: 3) {
			edges {
				node {
					id
					title

					slug {
						current
					}
					excerpt
					publishedAt(formatString: "MMMM DD, YYYY")
				}
			}
		}
	}
`;
